import vueMainInstance from "../../main";
import "lodash";
import TravelServiceOrder from "../../models/travelOrder/travelServiceOrder";
import TravelServiceOrderItem from "../../models/travelOrder/travelServiceOrderItem";
import TravelServiceOrderItemHotel from "../../models/travelOrder/travelServiceOrderItemHotel";
import TravelServiceOrderItemRail from "../../models/travelOrder/travelServiceOrderItemRail";
import TravelServiceOrderItemFlight from "../../models/travelOrder/travelServiceOrderItemFlight";
import TravelServiceOrderItemCar from "../../models/travelOrder/travelServiceOrderItemCar";
import UserModelClass from "../../models/travelOrder/userModel";
import TravelServiceOrderItemInsurance from "../../models/travelOrder/travelServiceOrderItemInsurance";
import { insuranceTypeID } from "../../staticData/TravelServiceTypes";
const uuidv4 = require("uuid/v4");

let importStartEndDate = (rootState, travelServiceOrderItemCarHotel) => {
  if (rootState.DelegationOrder.delegationOrderEdited.start_date !== null) {
    travelServiceOrderItemCarHotel.start_date = rootState.DelegationOrder.delegationOrderEdited.start_date;
  }
  if (rootState.DelegationOrder.delegationOrderEdited.end_date !== null) {
    travelServiceOrderItemCarHotel.end_date = rootState.DelegationOrder.delegationOrderEdited.end_date;
  }
};

let importRailOrFlight = (rootState, travelServiceOrderItemRailFlight) => {
  if (rootState.DelegationOrder.delegationOrderEdited.destination.length > 0) {
    travelServiceOrderItemRailFlight.end_place_id = rootState.DelegationOrder.delegationOrderEdited.destination[0];
  }
  if (rootState.DelegationOrder.delegationOrderEdited.start_place_id !== null) {
    travelServiceOrderItemRailFlight.start_place_id = rootState.DelegationOrder.delegationOrderEdited.start_place_id;
  }
  if (rootState.DelegationOrder.delegationOrderEdited.start_date !== null) {
    travelServiceOrderItemRailFlight.start_date = rootState.DelegationOrder.delegationOrderEdited.start_date;
  }
  if (rootState.DelegationOrder.delegationOrderEdited.end_date !== null) {
    travelServiceOrderItemRailFlight.return_date = rootState.DelegationOrder.delegationOrderEdited.end_date;
  }
};

let importDelegationOrderDataToTravelServiceOrderItem = (rootState, travelServiceOrderItem) => {
  if (vueMainInstance.$route.fullPath.includes("delegation-order")) {
    if (rootState.DelegationOrder.delegationOrderEdited.user_id !== null) {
      travelServiceOrderItem.travelServiceOrderItemPassengers[0].company_user_id = rootState.DelegationOrder.delegationOrderEdited.user_id;
    }
    if (rootState.DelegationOrder.delegationOrderEdited.cost_centre_id !== null && rootState.DelegationOrder.delegationOrderEdited.user_id !== null) {
      travelServiceOrderItem.cost_centre = rootState.TravelService.availableUsers
        .find(v => v.id === rootState.DelegationOrder.delegationOrderEdited.user_id)
        .costCentres.find(v => v.id === rootState.DelegationOrder.delegationOrderEdited.cost_centre_id).name;
    }
    if (travelServiceOrderItem.travelServiceOrderItemCar != null) {
      importStartEndDate(rootState, travelServiceOrderItem.travelServiceOrderItemCar);
      if (rootState.DelegationOrder.delegationOrderEdited.destination.length > 0) {
        travelServiceOrderItem.travelServiceOrderItemCar.start_place_id = rootState.DelegationOrder.delegationOrderEdited.destination[0];
      }
    }
    if (travelServiceOrderItem.travelServiceOrderItemHotel != null) {
      importStartEndDate(rootState, travelServiceOrderItem.travelServiceOrderItemHotel);
      if (rootState.DelegationOrder.delegationOrderEdited.destination.length > 0) {
        travelServiceOrderItem.travelServiceOrderItemHotel.place_id = rootState.DelegationOrder.delegationOrderEdited.destination[0];
      }
    }
    if (travelServiceOrderItem.travelServiceOrderItemRail != null) {
      importRailOrFlight(rootState, travelServiceOrderItem.travelServiceOrderItemRail);
    }
    if (travelServiceOrderItem.travelServiceOrderItemFlight != null) {
      importRailOrFlight(rootState, travelServiceOrderItem.travelServiceOrderItemFlight);
    }
    if (travelServiceOrderItem.travelServiceOrderItemInsurance != null) {
      importStartEndDate(rootState, travelServiceOrderItem.travelServiceOrderItemInsurance);
    }
  }
};

const namespaced = true;

const state = {
  asSeparated: false,
  editedTravelService: new TravelServiceOrder(),
  oldTravelService: new TravelServiceOrder(),
  editedTravelServiceItem: null,
  oldTravelServiceItem: null,
  availableUsers: [],
  availableCompanies: [],
  availableCostCentres: [],
  externalCustomers: [],
  companyContext: null,
  additionalParameters: [],
  createdIdCount: -1,
  newGuid: uuidv4()
};

const getters = {
  hasPermissionForEdit: (state, getters, rootState, rootGetters) => {
    if (state.editedTravelService === null) return false;
    if (state.editedTravelService.created_by_id === null) return true; //new order
    if (rootGetters.hasPermission("travelOrder")) return true;
    return rootState.Auth.userProperties.user_id === state.editedTravelService.created_by_id;
  },
  nextSequenceIndex: state => {
    let sequence = 0;
    for (let travelServiceItem of state.editedTravelService.travelServiceOrderItems) {
      if (travelServiceItem.sequence > sequence) {
        sequence = travelServiceItem.sequence;
      }
    }
    return sequence + 1;
  }
};

const mutations = {
  setAsSeparated(state, asSeparated) {
    state.asSeparated = asSeparated;
  },
  changeEditedTravelService(state, travelServiceOrder) {
    state.editedTravelService = travelServiceOrder;
  },
  setOldTravelService(state, travelServiceOrder) {
    state.oldTravelService = JSON.parse(JSON.stringify(travelServiceOrder));
  },
  setAvailableCompanies(state, { companyContext, availableCompanies }) {
    state.companyContext = companyContext;
    state.availableCompanies = availableCompanies;
  },
  setEditedTravelServiceItem(state, editedTravelServiceItem) {
    state.editedTravelServiceItem = editedTravelServiceItem;
  },
  setOldTravelServiceItem(state, editedTravelServiceItem) {
    state.oldTravelServiceItem = JSON.parse(JSON.stringify(editedTravelServiceItem));
  },
  setAdditionalParameters(state, additionalParameters) {
    state.additionalParameters = additionalParameters;
  },
  setAvailableUsers(state, availableUsers) {
    state.availableUsers = availableUsers;
  },
  setAvailableCostCentres(state, availableCostCentres) {
    state.availableCostCentres = availableCostCentres;
  },
  setExternalCustomers(state, externalCustomers) {
    state.externalCustomers = externalCustomers;
  },
  saveEditedServiceItem(state) {
    let item = state.editedTravelService.travelServiceOrderItems.find(v => {
      if (typeof v.tempId !== "undefined" && typeof state.editedTravelServiceItem.tempId !== "undefined" && v.tempId === state.editedTravelServiceItem.tempId)
        return true;
      if (v.id == null) return false;
      return v.id === state.editedTravelServiceItem.id;
    });
    if (typeof item === "undefined") {
      state.editedTravelService.travelServiceOrderItems.push(JSON.parse(JSON.stringify(state.editedTravelServiceItem)));
    } else {
      Object.assign(item, state.editedTravelServiceItem);
    }
  },
  nextId(state) {
    state.createdIdCount--;
    state.newGuid = uuidv4();
  }
};

const actions = {
  downloadAvailableUsers({ commit }) {
    return new Promise(resolve => {
      vueMainInstance.axios.get("travel-service/get-available-users").then(resp => {
        commit("setAvailableUsers", resp.data);
        resolve();
      });
    });
  },
  downloadAvailableCompanies({ commit, rootGetters, state }) {
    return new Promise((resolve, reject) => {
      if (rootGetters.companyContext === state.companyContext) {
        resolve(state.availableCompanies);
        return;
      }
      vueMainInstance.axios
        .get("travel-service/get-available-companies")
        .then(resp => {
          commit("setAvailableCompanies", { companyContext: rootGetters.companyContext, availableCompanies: resp.data });
          resolve(state.availableCompanies);
        })
        .catch(err => reject(err));
    });
  },
  openTravelServiceOrder({ commit, state }) {
    return new Promise((resolve, reject) => {
      commit("setAsSeparated", false);
      vueMainInstance.axios
        .get("travel-service/get-basic-data")
        .then(resp => {
          commit("setAvailableUsers", resp.data.availableUsers);
          commit("setAdditionalParameters", resp.data.additionalParameters);
          commit("setExternalCustomers", resp.data.externalCustomers);
          commit("setAvailableCostCentres", resp.data.costCentres);
          if (state.editedTravelService.additional_parameters.length === 0) {
            for (let additionalParam of resp.data.additionalParameters) {
              additionalParam.value = additionalParam.default_value;
            }
            let editedTravelService = state.editedTravelService;
            editedTravelService.additional_parameters = resp.data.additionalParameters;
            commit("changeEditedTravelService", editedTravelService);
            commit("setOldTravelService", editedTravelService);
          }
          resolve(resp.data);
        })
        .catch(err => reject(err));
    });
  },
  createNewTravelServiceOrder({ commit, rootGetters, rootState }) {
    let travelServiceOrder = new TravelServiceOrder();
    commit("setAsSeparated", false);
    travelServiceOrder.company_id = rootGetters.companyContextId;
    if (vueMainInstance.$route.fullPath.includes("delegation-order")) {
      travelServiceOrder.external_customer_id = rootState.DelegationOrder.delegationOrderEdited.external_customer_id;
      if (rootState.DelegationOrder.delegationOrderEdited.company_id !== null && rootState.DelegationOrder.delegationOrderEdited.company_id !== 0) {
        travelServiceOrder.company_id = rootState.DelegationOrder.delegationOrderEdited.company_id;
      }
      travelServiceOrder.project_id = rootState.DelegationOrder.delegationOrderEdited.project_id;
    }
    commit("changeEditedTravelService", travelServiceOrder);
    commit("setOldTravelService", travelServiceOrder);
  },
  editTravelServiceOrder({ commit }, travelServiceOrderId) {
    return new Promise((resolve, reject) => {
      commit("setAsSeparated", false);
      vueMainInstance.axios
        .get("/travel-service/get-service-order", {
          params: { id: travelServiceOrderId }
        })
        .then(resp => {
          for (let travelServiceOrderItem of resp.data.travelServiceOrderItems) {
            travelServiceOrderItem["cost_centre"] = travelServiceOrderItem.cost_centre_name;
          }
          commit("changeEditedTravelService", resp.data);
          commit("setOldTravelService", resp.data);
          resolve();
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  createHotelItem({ commit, rootState, rootGetters, state, getters }) {
    let travelServiceOrderItem = new TravelServiceOrderItem();
    travelServiceOrderItem.group_guid =
      state.editedTravelService.travelServiceOrderItems.length === 0 ? uuidv4() : state.editedTravelService.travelServiceOrderItems[0].group_guid;
    travelServiceOrderItem.tempId = state.createdIdCount;
    travelServiceOrderItem.guid = state.newGuid;
    travelServiceOrderItem.sequence = getters["nextSequenceIndex"];
    commit("nextId");
    travelServiceOrderItem.travelServiceOrderItemHotel = new TravelServiceOrderItemHotel();
    travelServiceOrderItem.travelServiceOrderItemPassengers.push(new UserModelClass());
    travelServiceOrderItem.type = "hotel";
    travelServiceOrderItem.travelServiceOrderItemHotel.is_insurance =
      parseInt(rootGetters["userProperties"].system_settings.travel_service_hotel_insurance) === 1;
    travelServiceOrderItem.travelServiceOrderItemHotel.parking_required = parseInt(rootGetters["userProperties"].system_settings.is_parking_required) === 1;
    travelServiceOrderItem.travelServiceOrderItemHotel.is_free_cancellation =
      parseInt(rootGetters["userProperties"].system_settings.is_free_cancellation_required) === 1;
    travelServiceOrderItem.travelServiceOrderItemHotel.is_breakfast = parseInt(rootGetters["userProperties"].system_settings.is_breakfast_required) === 1;
    importDelegationOrderDataToTravelServiceOrderItem(rootState, travelServiceOrderItem);
    commit("setEditedTravelServiceItem", travelServiceOrderItem);
    commit("setOldTravelServiceItem", travelServiceOrderItem);
  },
  createCarItem({ commit, rootState, rootGetters, state, getters }) {
    let travelServiceOrderItem = new TravelServiceOrderItem();
    travelServiceOrderItem.group_guid =
      state.editedTravelService.travelServiceOrderItems.length === 0 ? uuidv4() : state.editedTravelService.travelServiceOrderItems[0].group_guid;
    travelServiceOrderItem.tempId = state.createdIdCount;
    travelServiceOrderItem.guid = state.newGuid;
    travelServiceOrderItem.sequence = getters["nextSequenceIndex"];
    commit("nextId");
    travelServiceOrderItem.type = "car";
    travelServiceOrderItem.travelServiceOrderItemPassengers.push(new UserModelClass());
    travelServiceOrderItem.travelServiceOrderItemCar = new TravelServiceOrderItemCar();
    travelServiceOrderItem.travelServiceOrderItemCar.is_insurance = parseInt(rootGetters["userProperties"].system_settings.travel_service_car_insurance) === 1;
    importDelegationOrderDataToTravelServiceOrderItem(rootState, travelServiceOrderItem);
    commit("setEditedTravelServiceItem", travelServiceOrderItem);
    commit("setOldTravelServiceItem", travelServiceOrderItem);
  },
  createInsuranceItem({ commit, rootState, state, getters }) {
    let travelServiceOrderItem = new TravelServiceOrderItem();
    travelServiceOrderItem.group_guid =
      state.editedTravelService.travelServiceOrderItems.length === 0 ? uuidv4() : state.editedTravelService.travelServiceOrderItems[0].group_guid;
    travelServiceOrderItem.tempId = state.createdIdCount;
    travelServiceOrderItem.guid = state.newGuid;
    travelServiceOrderItem.sequence = getters["nextSequenceIndex"];

    commit("nextId");
    travelServiceOrderItem.type = "insurance";
    travelServiceOrderItem.travelServiceOrderItemPassengers.push(new UserModelClass());
    travelServiceOrderItem.travelServiceOrderItemInsurance = new TravelServiceOrderItemInsurance();
    importDelegationOrderDataToTravelServiceOrderItem(rootState, travelServiceOrderItem);
    commit("setEditedTravelServiceItem", travelServiceOrderItem);
    commit("setOldTravelServiceItem", travelServiceOrderItem);
  },
  createFlightItem({ commit, rootState, rootGetters, state, getters }) {
    let travelServiceOrderItem = new TravelServiceOrderItem();
    travelServiceOrderItem.group_guid =
      state.editedTravelService.travelServiceOrderItems.length === 0 ? uuidv4() : state.editedTravelService.travelServiceOrderItems[0].group_guid;
    travelServiceOrderItem.tempId = state.createdIdCount;
    travelServiceOrderItem.guid = state.newGuid;
    travelServiceOrderItem.sequence = getters["nextSequenceIndex"];
    commit("nextId");
    travelServiceOrderItem.type = "flight";
    travelServiceOrderItem.travelServiceOrderItemFlight = new TravelServiceOrderItemFlight();
    travelServiceOrderItem.travelServiceOrderItemPassengers.push(new UserModelClass());
    travelServiceOrderItem.travelServiceOrderItemFlight.is_insurance =
      parseInt(rootGetters["userProperties"].system_settings.travel_service_flight_insurance) === 1;
    travelServiceOrderItem.travelServiceOrderItemFlight.is_baggage =
      parseInt(rootGetters["userProperties"].system_settings.registered_baggage_will_be_assigned) === 1;
    travelServiceOrderItem.travelServiceOrderItemFlight.return_date =
      parseInt(rootGetters["userProperties"].system_settings.flight_is_return_route) === 1 ? "" : null;
    importDelegationOrderDataToTravelServiceOrderItem(rootState, travelServiceOrderItem);
    commit("setEditedTravelServiceItem", travelServiceOrderItem);
    commit("setOldTravelServiceItem", travelServiceOrderItem);
  },
  createRailItem({ commit, rootState, rootGetters, state, getters }) {
    let travelServiceOrderItem = new TravelServiceOrderItem();
    travelServiceOrderItem.group_guid =
      state.editedTravelService.travelServiceOrderItems.length === 0 ? uuidv4() : state.editedTravelService.travelServiceOrderItems[0].group_guid;
    travelServiceOrderItem.tempId = state.createdIdCount;
    travelServiceOrderItem.guid = state.newGuid;
    travelServiceOrderItem.sequence = getters["nextSequenceIndex"];
    commit("nextId");
    travelServiceOrderItem.type = "rail";
    travelServiceOrderItem.travelServiceOrderItemRail = new TravelServiceOrderItemRail();
    travelServiceOrderItem.travelServiceOrderItemPassengers.push(new UserModelClass());
    travelServiceOrderItem.travelServiceOrderItemRail.is_insurance =
      parseInt(rootGetters["userProperties"].system_settings.travel_service_rail_insurance) === 1;
    importDelegationOrderDataToTravelServiceOrderItem(rootState, travelServiceOrderItem);
    commit("setEditedTravelServiceItem", travelServiceOrderItem);
    commit("setOldTravelServiceItem", travelServiceOrderItem);
  },
  createOtherItem({ commit, rootState, state, getters }) {
    let travelServiceOrderItem = new TravelServiceOrderItem();
    travelServiceOrderItem.group_guid =
      state.editedTravelService.travelServiceOrderItems.length === 0 ? uuidv4() : state.editedTravelService.travelServiceOrderItems[0].group_guid;
    travelServiceOrderItem.tempId = state.createdIdCount;
    travelServiceOrderItem.guid = state.newGuid;
    travelServiceOrderItem.sequence = getters["nextSequenceIndex"];
    commit("nextId");
    travelServiceOrderItem.type = "other";
    travelServiceOrderItem.travelServiceOrderItemPassengers.push(new UserModelClass());
    importDelegationOrderDataToTravelServiceOrderItem(rootState, travelServiceOrderItem);
    commit("setEditedTravelServiceItem", travelServiceOrderItem);
    commit("setOldTravelServiceItem", travelServiceOrderItem);
  },
  addPassenger({ state }) {
    let editedTravelServiceItem = state.editedTravelServiceItem;
    editedTravelServiceItem.travelServiceOrderItemPassengers.push(new UserModelClass());
  },
  saveEditedServiceItem({ state, commit, dispatch, rootGetters, getters }) {
    let travelServiceOrderItem = JSON.parse(JSON.stringify(state.editedTravelServiceItem));
    let findStartFlightDate = travelServiceOrderItemFlight => {
      let startDate = travelServiceOrderItemFlight.start_date;
      for (let segment of travelServiceOrderItemFlight.additionalSegments) {
        if (startDate > segment.start_date) {
          startDate = segment.start_date;
        }
      }
      return startDate;
    };

    let findEndFlightDate = travelServiceOrderItemFlight => {
      // eslint-disable-next-line
      let endDate = !!travelServiceOrderItemFlight.return_date ? travelServiceOrderItemFlight.return_date : travelServiceOrderItemFlight.start_date;
      for (let segment of travelServiceOrderItemFlight.additionalSegments) {
        if (endDate < segment.start_date) {
          endDate = segment.start_date;
        }
      }
      return endDate;
    };

    let updateInsuranceBasedOnServiceItem = travelServiceOrderItemNew => {
      travelServiceOrderItemNew.travelServiceOrderItemPassengers = JSON.parse(JSON.stringify(travelServiceOrderItem.travelServiceOrderItemPassengers));
      travelServiceOrderItemNew.comment = travelServiceOrderItem.comment;
      if (travelServiceOrderItem.travelServiceOrderItemFlight !== null) {
        travelServiceOrderItemNew.travelServiceOrderItemInsurance.start_date = findStartFlightDate(travelServiceOrderItem.travelServiceOrderItemFlight);
        travelServiceOrderItemNew.travelServiceOrderItemInsurance.end_date = findEndFlightDate(travelServiceOrderItem.travelServiceOrderItemFlight);
        travelServiceOrderItemNew.travelServiceOrderItemInsurance.place_id = travelServiceOrderItem.travelServiceOrderItemFlight.end_place_id;
      }
      if (travelServiceOrderItem.travelServiceOrderItemRail !== null) {
        travelServiceOrderItemNew.travelServiceOrderItemInsurance.start_date = travelServiceOrderItem.travelServiceOrderItemRail.start_date;
        // eslint-disable-next-line
        travelServiceOrderItemNew.travelServiceOrderItemInsurance.end_date = !!travelServiceOrderItem.travelServiceOrderItemRail.return_date
          ? travelServiceOrderItem.travelServiceOrderItemRail.return_date
          : travelServiceOrderItem.travelServiceOrderItemRail.start_date;
        travelServiceOrderItemNew.travelServiceOrderItemInsurance.place_id = travelServiceOrderItem.travelServiceOrderItemRail.end_place_id;
      }
      if (travelServiceOrderItem.travelServiceOrderItemHotel !== null) {
        travelServiceOrderItemNew.travelServiceOrderItemInsurance.start_date = travelServiceOrderItem.travelServiceOrderItemHotel.start_date;
        travelServiceOrderItemNew.travelServiceOrderItemInsurance.end_date = travelServiceOrderItem.travelServiceOrderItemHotel.end_date;
        travelServiceOrderItemNew.travelServiceOrderItemInsurance.place_id = travelServiceOrderItem.travelServiceOrderItemHotel.place_id;
      }
      if (travelServiceOrderItem.travelServiceOrderItemCar !== null) {
        travelServiceOrderItemNew.travelServiceOrderItemInsurance.start_date = travelServiceOrderItem.travelServiceOrderItemCar.start_date;
        travelServiceOrderItemNew.travelServiceOrderItemInsurance.end_date = travelServiceOrderItem.travelServiceOrderItemCar.end_date;
        travelServiceOrderItemNew.travelServiceOrderItemInsurance.place_id = travelServiceOrderItem.travelServiceOrderItemCar.start_place_id;
      }
      travelServiceOrderItemNew.cost_centre = travelServiceOrderItem.cost_centre;
      return travelServiceOrderItemNew;
    };

    let createInsuranceBasedOnServiceItem = () => {
      let travelServiceOrderItemNew = new TravelServiceOrderItem();
      travelServiceOrderItemNew.tempId = state.createdIdCount;
      travelServiceOrderItemNew.guid = state.newGuid;
      travelServiceOrderItemNew.sequence = getters["nextSequenceIndex"];
      travelServiceOrderItemNew.group_guid =
        state.editedTravelService.travelServiceOrderItems.length === 0 ? uuidv4() : state.editedTravelService.travelServiceOrderItems[0].group_guid;
      commit("nextId");
      travelServiceOrderItemNew.type = "insurance";
      travelServiceOrderItemNew.travelServiceOrderItemInsurance = new TravelServiceOrderItemInsurance();
      travelServiceOrderItemNew.related_sequence = travelServiceOrderItem.sequence;
      travelServiceOrderItemNew.related_travel_service_order_item_guid = travelServiceOrderItem.guid;
      travelServiceOrderItemNew = updateInsuranceBasedOnServiceItem(travelServiceOrderItemNew);
      return travelServiceOrderItemNew;
    };

    if (travelServiceOrderItem.travelServiceOrderItemFlight !== null) {
      if (rootGetters["userProperties"].system_settings.travel_service_hotel_available) {
        dispatch(
          "confirmDialog",
          {
            content: vueMainInstance.$t("travelService.orderServicesCustomerForm.hotelRequiredDialog.content"),
            title: vueMainInstance.$t("travelService.orderServicesCustomerForm.hotelRequiredDialog.title")
          },
          { root: true }
        )
          .then(() => {
            dispatch("createHotelItem").then(() => {
              let travelServiceOrderHotelItem = state.editedTravelServiceItem;
              travelServiceOrderHotelItem.related_sequence = travelServiceOrderItem.sequence;
              travelServiceOrderHotelItem.related_travel_service_order_item_guid = travelServiceOrderItem.guid;
              travelServiceOrderHotelItem.travelServiceOrderItemHotel.place_id = travelServiceOrderItem.travelServiceOrderItemFlight.end_place_id;
              travelServiceOrderHotelItem.travelServiceOrderItemPassengers = JSON.parse(
                JSON.stringify(travelServiceOrderItem.travelServiceOrderItemPassengers)
              );
              travelServiceOrderHotelItem.comment = travelServiceOrderItem.comment;
              travelServiceOrderHotelItem.travelServiceOrderItemHotel.start_date = travelServiceOrderItem.travelServiceOrderItemFlight.start_date;
              travelServiceOrderHotelItem.travelServiceOrderItemHotel.end_date = travelServiceOrderItem.travelServiceOrderItemFlight.return_date;
              travelServiceOrderHotelItem.cost_centre = travelServiceOrderItem.cost_centre;
              commit("setEditedTravelServiceItem", travelServiceOrderHotelItem);
            });
          })
          .catch();
      }
      if (rootGetters["userProperties"].system_settings.travel_service_car_available) {
        dispatch(
          "confirmDialog",
          {
            content: vueMainInstance.$t("travelService.orderServicesCustomerForm.carRequiredDialog.content"),
            title: vueMainInstance.$t("travelService.orderServicesCustomerForm.carRequiredDialog.title")
          },
          { root: true }
        )
          .then(() => {
            dispatch("createCarItem").then(() => {
              let travelServiceOrderCarItem = state.editedTravelServiceItem;
              travelServiceOrderCarItem.related_sequence = travelServiceOrderItem.sequence;
              travelServiceOrderCarItem.related_travel_service_order_item_guid = travelServiceOrderItem.guid;
              travelServiceOrderCarItem.travelServiceOrderItemCar.start_place_id = travelServiceOrderItem.travelServiceOrderItemFlight.end_place_id;
              travelServiceOrderCarItem.travelServiceOrderItemPassengers = JSON.parse(JSON.stringify(travelServiceOrderItem.travelServiceOrderItemPassengers));
              travelServiceOrderCarItem.comment = travelServiceOrderItem.comment;
              travelServiceOrderCarItem.travelServiceOrderItemCar.start_date = travelServiceOrderItem.travelServiceOrderItemFlight.start_date;
              travelServiceOrderCarItem.travelServiceOrderItemCar.end_date = travelServiceOrderItem.travelServiceOrderItemFlight.return_date;
              travelServiceOrderCarItem.cost_centre = travelServiceOrderItem.cost_centre;
              commit("setEditedTravelServiceItem", travelServiceOrderCarItem);
            });
          })
          .catch();
      }
    }
    if (travelServiceOrderItem.travelServiceOrderItemRail !== null) {
      if (rootGetters["userProperties"].system_settings.travel_service_hotel_available) {
        dispatch(
          "confirmDialog",
          {
            content: vueMainInstance.$t("travelService.orderServicesCustomerForm.hotelRequiredDialog.content"),
            title: vueMainInstance.$t("travelService.orderServicesCustomerForm.hotelRequiredDialog.title")
          },
          { root: true }
        )
          .then(() => {
            dispatch("createHotelItem").then(() => {
              let travelServiceOrderHotelItem = state.editedTravelServiceItem;
              travelServiceOrderHotelItem.related_sequence = travelServiceOrderItem.sequence;
              travelServiceOrderHotelItem.related_travel_service_order_item_guid = travelServiceOrderItem.guid;
              travelServiceOrderHotelItem.travelServiceOrderItemHotel.place_id = travelServiceOrderItem.travelServiceOrderItemRail.end_place_id;
              travelServiceOrderHotelItem.travelServiceOrderItemPassengers = JSON.parse(
                JSON.stringify(travelServiceOrderItem.travelServiceOrderItemPassengers)
              );
              travelServiceOrderHotelItem.comment = travelServiceOrderItem.comment;
              travelServiceOrderHotelItem.travelServiceOrderItemHotel.start_date = travelServiceOrderItem.travelServiceOrderItemRail.start_date;
              travelServiceOrderHotelItem.travelServiceOrderItemHotel.end_date = travelServiceOrderItem.travelServiceOrderItemRail.return_date;
              travelServiceOrderHotelItem.cost_centre = travelServiceOrderItem.cost_centre;
              commit("setEditedTravelServiceItem", travelServiceOrderHotelItem);
            });
          })
          .catch();
      }
      if (rootGetters["userProperties"].system_settings.travel_service_car_available) {
        dispatch(
          "confirmDialog",
          {
            content: vueMainInstance.$t("travelService.orderServicesCustomerForm.carRequiredDialog.content"),
            title: vueMainInstance.$t("travelService.orderServicesCustomerForm.carRequiredDialog.title")
          },
          { root: true }
        )
          .then(() => {
            dispatch("createCarItem").then(() => {
              let travelServiceOrderCarItem = state.editedTravelServiceItem;
              travelServiceOrderCarItem.related_sequence = travelServiceOrderItem.sequence;
              travelServiceOrderCarItem.related_travel_service_order_item_guid = travelServiceOrderItem.guid;
              travelServiceOrderCarItem.travelServiceOrderItemCar.start_place_id = travelServiceOrderItem.travelServiceOrderItemRail.end_place_id;
              travelServiceOrderCarItem.travelServiceOrderItemPassengers = JSON.parse(JSON.stringify(travelServiceOrderItem.travelServiceOrderItemPassengers));
              travelServiceOrderCarItem.comment = travelServiceOrderItem.comment;
              travelServiceOrderCarItem.travelServiceOrderItemCar.start_date = travelServiceOrderItem.travelServiceOrderItemRail.start_date;
              travelServiceOrderCarItem.travelServiceOrderItemCar.end_date = travelServiceOrderItem.travelServiceOrderItemRail.return_date;
              travelServiceOrderCarItem.cost_centre = travelServiceOrderItem.cost_centre;
              commit("setEditedTravelServiceItem", travelServiceOrderCarItem);
            });
          })
          .catch();
      }
    }
    commit("saveEditedServiceItem");
    commit("setEditedTravelServiceItem", null);
    commit("setOldTravelServiceItem", null);

    let relatedItems = state.editedTravelService.travelServiceOrderItems.filter(v => v.related_sequence === travelServiceOrderItem.sequence);

    if (relatedItems.length > 0) {
      for (let relatedItem of relatedItems) {
        if (relatedItem.type === "insurance") {
          updateInsuranceBasedOnServiceItem(relatedItem);
          dispatch(
            "snackbarPush",
            {
              text: vueMainInstance.$t("travelService.assignedInsuranceUpdated"),
              position: "down"
            },
            { root: true }
          );
        }
      }
      commit("changeEditedTravelService", state.editedTravelService);
    } else if (
      (travelServiceOrderItem.travelServiceOrderItemFlight !== null &&
        rootGetters["userProperties"].system_settings.travel_service_flight_insurance === insuranceTypeID.INSURANCE_ASK) ||
      (travelServiceOrderItem.travelServiceOrderItemRail !== null &&
        rootGetters["userProperties"].system_settings.travel_service_rail_insurance === insuranceTypeID.INSURANCE_ASK) ||
      (travelServiceOrderItem.travelServiceOrderItemCar !== null &&
        rootGetters["userProperties"].system_settings.travel_service_car_insurance === insuranceTypeID.INSURANCE_ASK) ||
      (travelServiceOrderItem.travelServiceOrderItemHotel !== null &&
        rootGetters["userProperties"].system_settings.travel_service_hotel_insurance === insuranceTypeID.INSURANCE_ASK)
    ) {
      dispatch(
        "confirmDialog",
        {
          content: vueMainInstance.$t("travelService.orderServicesCustomerForm.insuranceRequiredDialog.content"),
          title: vueMainInstance.$t("travelService.orderServicesCustomerForm.insuranceRequiredDialog.title")
        },
        { root: true }
      )
        .then(() => {
          let travelServiceOrderInsuranceItem = createInsuranceBasedOnServiceItem();
          commit("setEditedTravelServiceItem", travelServiceOrderInsuranceItem);
          commit("setOldTravelServiceItem", travelServiceOrderItem);
        })
        .catch();
    } else if (
      (travelServiceOrderItem.travelServiceOrderItemFlight !== null &&
        rootGetters["userProperties"].system_settings.travel_service_flight_insurance === insuranceTypeID.INSURANCE_ADD) ||
      (travelServiceOrderItem.travelServiceOrderItemRail !== null &&
        rootGetters["userProperties"].system_settings.travel_service_rail_insurance === insuranceTypeID.INSURANCE_ADD) ||
      (travelServiceOrderItem.travelServiceOrderItemCar !== null &&
        rootGetters["userProperties"].system_settings.travel_service_car_insurance === insuranceTypeID.INSURANCE_ADD) ||
      (travelServiceOrderItem.travelServiceOrderItemHotel !== null &&
        rootGetters["userProperties"].system_settings.travel_service_hotel_insurance === insuranceTypeID.INSURANCE_ADD)
    ) {
      let travelServiceOrderInsuranceItem = createInsuranceBasedOnServiceItem();
      let travelService = state.editedTravelService;
      travelService.travelServiceOrderItems.push(travelServiceOrderInsuranceItem);
      commit("changeEditedTravelService", travelService);
    }
  },
  saveEditedService({ state, commit }) {
    return new Promise(resolv => {
      let travelServices = [state.editedTravelService];

      if (state.asSeparated) {
        travelServices = [];
        for (let item of state.editedTravelService.travelServiceOrderItems.filter(v => v.type !== "insurance" || v.related_sequence === null)) {
          let travelService = JSON.parse(JSON.stringify(state.editedTravelService));
          travelService.travelServiceOrderItems = travelService.travelServiceOrderItems.filter(
            v => v.sequence === item.sequence || (v.related_sequence === item.sequence && v.type === "insurance")
          );
          travelServices.push(travelService);
        }
      }

      let promises = [];

      for (let travelService of travelServices) {
        promises.push(
          new Promise((resolve, reject) => {
            vueMainInstance.axios
              .post("/travel-service/edit-service-order", travelService)
              .then(resp => {
                resolve(resp.data.id);
              })
              .catch(err => {
                reject(err);
                console.log(err);
                //alert("Błąd, skontaktuj się z administratorem");
              });
          })
        );
      }

      Promise.all(promises).then(serviceOrderIds => {
        commit("setOldTravelService", state.editedTravelService);
        resolv(serviceOrderIds);
      });
    });
  }
};

export default {
  namespaced,
  state,
  getters,
  actions,
  mutations
};
